import React from 'react'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import { IconButton, Tooltip } from '@mui/material'

type HelpButtonProps = {
	onClick: () => void
}

const HelpButton = ({ onClick }: HelpButtonProps) => {
	return (
		<Tooltip title='Help for this page'>
			<IconButton
				onClick={onClick}
				aria-label='Open help for this page'
				color='inherit'
				size='medium'
				sx={{ ml: 1 }}
			>
				<HelpOutlineIcon />
			</IconButton>
		</Tooltip>
	)
}

export default HelpButton
